// Environment configuration for the frontend
// This allows easy switching between development and network deployment

const config = {
  // Go backend configuration
  GO_BACKEND_URL:
    process.env.REACT_APP_GO_BACKEND_URL || "",

  // WebRTC configuration
  ICE_SERVERS: [
    { urls: "stun:stun.l.google.com:19302" },
    { urls: "stun:stun1.l.google.com:19302" },
    { urls: "stun:stun2.l.google.com:19302" },
    { urls: "stun:stun3.l.google.com:19302" },
    { urls: "stun:stun4.l.google.com:19302" },
  ],
};

export default config;
